import React, {useEffect, useState} from 'react';
import axios from 'axios';
import SelectAttendance from "./components/popups/SelectAttendance";
import AttendanceOK from "./components/popups/AttendanceOK";
import AttendanceFail from "./components/popups/AttendanceFail";
import {ToggleDarkBackground} from "../components/common/Common";

import logoIcon from "../img/logo/logo.svg";

//입출결 인증
const Attendance = () => {
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const [varChildrenList,setChildrenList] = useState([]);
  const [varChildrenStudyList,setChildrenStudyList] = useState([]);

  const newItem = {login_id:"",login_pwd:""};
  const [varLoginInfo,setLoginInfo] = useState({});

  const [varPopupChildrens,setPopupChildrens] = useState(false);
  const [varPopupAttendanceOK,setPopupAttendanceOK] = useState(false);
  const [varPopupAttendanceFail,setPopupAttendanceFail] = useState(false);

  const [varFailMessage,setFailMessage] = useState('');

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setLoginInfo(newItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //로그인정보 입력
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    setLoginInfo({...varLoginInfo,[name]:value});
  }

  //출석확인을 위한 정보호출
  const GetAttendanceInformation = async() => {
    const sendData = {bh_idx:branch_idx,dataInfo:varLoginInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_attendance_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.studys.length === 0) {
          ToggleDarkBackground(true);
          setPopupAttendanceFail(true);
          setFailMessage('출석할 수업이 없습니다.');
        } else if(datas.studys.length === 1) { //원생 1명만 수업이 있는 경우
          const childrenInfo = datas.studys[0];
          if(childrenInfo.csc_status === 2) {
            alert(`이미 ${childrenInfo.ch_name} 원생은 출석체크 되셨습니다.`); 
            setLoginInfo(newItem);
            return false;
          }
          //출석체크---
          setChildrenStudyList(datas.studys);
          UpdateAttendanceInformation(childrenInfo.csc_idx,childrenInfo.csc_cl_idx,childrenInfo.csc_ch_idx,childrenInfo.cs_idx);
        } else {  //자녀가 두명이상이 오늘 수업이 있을 경우
          setChildrenStudyList(datas.studys);
          let ifound = false;
          //원생을 직접 지정한 경우
          if(varLoginInfo.login_pwd.length === 6) {
            const findIndex = datas.childrens.findIndex(el=>el.ch_code === varLoginInfo.login_pwd);
            if(findIndex > -1) {
              const ch_idx = datas.childrens[findIndex].ch_idx;
              const childrenInfo = datas.studys.find(el=>el.csc_ch_idx === ch_idx);
              if(childrenInfo.csc_status === 2) {
                alert(`이미 ${childrenInfo.ch_name} 원생은 출석체크 되셨습니다.`); 
                setLoginInfo(newItem);
                return false;
              }
              ifound = true;
              UpdateAttendanceInformation(childrenInfo.csc_idx,childrenInfo.csc_cl_idx,childrenInfo.csc_ch_idx,childrenInfo.cs_idx);
            }
          } else {
            const childrenList = datas.studys.filter(el=>el.csc_status === 1);
            if(childrenList.length === 1){  //한명이 미출석등록한 경우
              const childrenInfo = childrenList[0];
              ifound = true;
              UpdateAttendanceInformation(childrenInfo.csc_idx,childrenInfo.csc_cl_idx,childrenInfo.csc_ch_idx,childrenInfo.cs_idx);
            } else if(childrenList.length === 0){ //모두가 이미 출석등록한 경우
              alert(`이미 원생들이 모두 출석체크 되셨습니다.`); 
              setLoginInfo(newItem);
              return false;
            }
          }
          if(!ifound) {
            const childrens = datas.childrens;
            let childrenList = [];
            for(var i = 0; i < childrens.length; i++) {
              let ch_idx = childrens[i].ch_idx;
              let findIndex = datas.studys.findIndex(el=>el.csc_ch_idx===ch_idx);
              if(findIndex > -1) childrenList.push(childrens[i]);
            }
            setChildrenList(childrenList);
            ToggleDarkBackground(true);
            setPopupChildrens(true);
          }
        }
      } else {
        ToggleDarkBackground(true);
        setPopupAttendanceFail(true);
        setFailMessage(datas.message);
      }
    });
  }

  //출석정보 등록
  const UpdateAttendanceInformation = async(csc_idx,cl_idx,ch_idx,cs_idx) => {
    const sendData = {csc_idx:csc_idx,cl_idx:cl_idx,ch_idx:ch_idx,cs_idx:cs_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_attendance_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setPopupAttendanceOK(true);
      } else {
        setPopupAttendanceFail(true);
        setFailMessage(datas.message);
      }
    });
  }

  //수업출석확인
  const onAttendanceHandler = (e) => {
    if(varLoginInfo.login_id === "") {
      alert("아이디를 먼저 입력하세요."); return false;
    } else if(varLoginInfo.login_id === "") {
      alert("비밀번호를 먼저 입력하세요."); return false;
    }
    GetAttendanceInformation();
  }

  //팝업창닫기 - 원생 선택없음
  const onClosePopupChildrensHandler = (e) => {
    ToggleDarkBackground(false);
    setPopupChildrens(false);
    setPopupAttendanceFail(true);
    setFailMessage('출석을 등록할 원생을 선택하지 않았습니다. 출석등록을 다시 진행해주세요.');
  }
  ///팝업창닫기 - 원생 선택
  const onSelectChildrenHandler = (e,ch_idx) => {
    ToggleDarkBackground(false);
    setPopupChildrens(false);
    //console.log(ch_idx,varChildrenStudyList);
    const childrenInfo = varChildrenStudyList.find(el=>el.csc_ch_idx===ch_idx);
    UpdateAttendanceInformation(childrenInfo.csc_idx,childrenInfo.csc_cl_idx,childrenInfo.csc_ch_idx,childrenInfo.cs_idx);
  }

  //팝업창 닫기 - 출석성곰
  const onCloseInitHandler = (e,inum) => {
    ToggleDarkBackground(false);
    if(inum === 0) setPopupAttendanceOK(false);
    else setPopupAttendanceFail(false);
    setLoginInfo(newItem);
  } 

  return (
    <div className="check-form-wrap">
      <div className="layer-bg"></div>
      <div className="check-txt">입출결 인증</div> 
      <div className="check-logo mb50"><img src={logoIcon} alt=""/></div>
      <div className="chk-form mb25">
				<div className="field-group mb20">
					<span>아이디</span>
          <input type="text" name="login_id" value={varLoginInfo.login_id||""} placeholder="아이디를 입력하세요." className="form-control form-id" onChange={e=>onChangeInputHandler(e)}/>
        </div>
        <div className="field-group mb20">
          <span>비밀번호</span>
          <input type="password" name="login_pwd" value={varLoginInfo.login_pwd||""} placeholder="비밀번호를 입력하세요." className="form-control form-pw" onChange={e=>onChangeInputHandler(e)}/>
        </div>
        <div className="form-contoller flex-vertical">
          <button className="form-contoller-btn btn-100" onClick={e=>onAttendanceHandler(e)}>출석등록</button>
        </div>
      </div>
      <SelectAttendance varPopupChildrens={varPopupChildrens} varChildrenList={varChildrenList} 
            onClosePopupChildrensHandler={onClosePopupChildrensHandler} onSelectChildrenHandler={onSelectChildrenHandler}/>
      <AttendanceOK varPopupAttendanceOK={varPopupAttendanceOK} setPopupAttendanceOK={setPopupAttendanceOK} onCloseInitHandler={onCloseInitHandler}/>
      <AttendanceFail varPopupAttendanceFail={varPopupAttendanceFail} setPopupAttendanceFail={setPopupAttendanceFail} varFailMessage={varFailMessage} onCloseInitHandler={onCloseInitHandler}/>
    </div>
  );
}
export default Attendance;